import { get } from 'lodash';
import { createSelector } from 'reselect';

export const allParentDomainIdsSelector = state => get( state, 'claimedDomainsWithCounts.allParentDomainIds', [] );
export const allSubdomainIdsSelector = state => get( state, 'claimedDomainsWithCounts.allSubdomainIds', [] );
export const byIdSelector = state => get( state, 'claimedDomainsWithCounts.byId', {} );
export const claimedDomainsWithCountsIsLoadingSelector = state => get( state, 'claimedDomainsWithCounts.isLoading', false );

// Params
export const claimedParamsSelector = state => get( state, 'claimedDomainsWithCounts.params', null );
export const claimedFilterParamsSelector = state => get( state, 'claimedDomainsWithCounts.filterParams', null );

// Pagination
export const claimedCurrentPageSelector = state => get( state, 'claimedDomainsWithCounts.pagination.currentPage', 1 );
export const claimedTotalPagesSelector = state => get( state, 'claimedDomainsWithCounts.pagination.totalPages', 1 );
export const claimedTotalItemsSelector = state => get( state, 'claimedDomainsWithCounts.pagination.totalItemCount', 0 );

export const claimedParentDomainsWithCountsSelector = createSelector(
    allParentDomainIdsSelector,
    byIdSelector,
    ( parentDomainIds, domainMap ) => parentDomainIds.map( id => domainMap[id] )
);

export const claimedSubdomainsWithCountsSelector = createSelector(
    allSubdomainIdsSelector,
    byIdSelector,
    ( subdomainIds, domainMap ) => subdomainIds.map( id => domainMap[id] )
);
